import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FileUtilsService } from '../../../_helpers/file-utils.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDate, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, filter, finalize, map, takeUntil, tap } from 'rxjs/operators';
import { BatchStatusV2, BatchTypeV2, CreationBatch, StatusBatch, TypeBatch } from 'src/app/_enums';
import { AppConfig, CustomDatepickerI18n, WindowService } from 'src/app/_helpers';
import { BatchFilesDetails, BatchList, BatchListData } from 'src/app/_models/batchProcess.interface';
import { ConfigurationService, I18n, ProcessService } from 'src/app/_services';
import { arrowNarrowIcon, bluePlusIcon, calendarIcon, checkOutlineIcon, copyIcon, csvFileIcon, dotsVerticalIcon, editIcon, filterLinesIcon, searchIcon, txtFileIcon, uploadArrowIcon, xlsFileIcon, xlsxFileIcon } from 'src/app/sharedcomp/constans/icons.constans';
import * as fs from 'file-saver';
import { error } from 'console';
import { HttpErrorResponse } from '@angular/common/http';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-new-batches-version',
  templateUrl: './new-batches-version.component.html',
  styleUrls: [
    './new-batches-version.component.css',
    '../../../../assets/css/new-component-view.css',
    '../../../../assets/css/new-form-elements.css',
    '../../../../assets/css/new-buttons-theme.css',
    '../../../sharedcomp/ui-components/drpdowns/dropdown/dropdown.component.css',
    '../../../../assets/css/new-date-range-picker.css'
  ],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class NewBatchesVersionComponent implements OnInit, AfterViewInit, OnDestroy {

  kashioApplication: string;
  configurationStatus: string;

  dataSource: MatTableDataSource<BatchListData> = new MatTableDataSource([]);
  displayedColumns: string[] = ['name', 'created', 'generated_by', 'type', 'status', 'actions'];
  displayLoaderSpinner: boolean = false;
  totalSize: number = 0;
  pageSize: number;
  PageSizeOptions: number[];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  batchesList: BatchListData[] = [];

  icons: Record<string, { path: string; alt: string }>;
  typeOptions: BatchTypeV2[];
  stateOptions: BatchStatusV2[];
  ddlCreation: { value: number; name: string }[];

  searchFilterForm: FormGroup;

  creationFormControl: FormControl = new FormControl(8);
  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  displayMonths: number;
  hoveredDate: NgbDate | null = null;
  dateText: string;

  typeSelectedValue: number = 0;
  stateSelectedValue: number = 0;

  state: number = 0;
  type: number = 0;

  showOverlay: boolean = false;
  customerPublicID: string;

  batchDetails: BatchFilesDetails | {} = {};
  userName: string = "";

  stateConfig = {
    '1': { class: 'base-state sky-blue', cssStyle: { 'color': '#2E90FA' }, text: 'Nuevo' },
    '2': { class: 'base-state blue', cssStyle: { 'color': '#287BEE' }, text: 'En Proceso' },
    '3': { class: 'base-state blue', cssStyle: { 'color': '#287BEE' }, text: 'En Proceso' },
    '4': { class: 'base-state red', cssStyle: { 'color': '#F04438' }, text: 'No Procesado' },
    '5': { class: 'base-state blue', cssStyle: { 'color': '#287BEE' }, text: 'En Proceso' },
    '6': { class: 'base-state green', cssStyle: { 'color': '#17B26A' }, text: 'Completado' }
  };

  startDate: string = "All";
  endDate: string = "All";

  offsetTimeZone: number;
  offsetMinutes: number;
  offsetTimeVal: number;
  @Input() message: { title: string; description: string; };

  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    protected typeBatch: TypeBatch,
    protected stateBatch: StatusBatch,
    protected statusBatch: StatusBatch,
    protected creation: CreationBatch,
    private windowService: WindowService,
    private processService: ProcessService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private configurationService: ConfigurationService,
    public fileUtilsService: FileUtilsService
  ) {
    this.icons = this.setIcons();
    this.typeOptions = this.typeBatch._batchesTypeV2;
    this.stateOptions = this.stateBatch._batchesStatusV2;
    this.ddlCreation = this.creation._newCreation;
    this.initSearchForm();
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
  }

  ngOnInit() {
    this.displayMonths = window.innerWidth > 1070 ? 2 : 1;
    this.listenWindowWidth();

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.checkCredentials();
    this.setTimeParameters();
    this.kashioApplication = localStorage.getItem('application');
    this.getConfigList();
    this.getProcessDetails();
  }

  ngAfterViewInit() {
    this.customSortColumns();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  customSortColumns() {
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'status':
          return this.stateConfig[item.status.toString()] ? this.stateConfig[item.status.toString()].text : '';
        default:
          return item[property];
      }
    };
  }
  checkCredentials() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicID = localStorage.getItem('companyId');
      }
    } else {
      this.customerPublicID = localStorage.getItem('subcompanyId');
    }
  }

  setTimeParameters() {
    let browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    const offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (offsetTimeZone == null || offsetTimeZone === 'undefined' || Number.isNaN(+offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal.toString();
    } else {
      this.offsetTimeZone = Number(offsetTimeZone);
      this.offsetMinutes = 30;
      this.offsetTimeVal = (3600000 * this.offsetTimeZone);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal.toString();
    }
  }

  getConfigList() {
    if (this.kashioApplication !== 'PAYOUTS') {
      this.configurationService.getConfigurationList(this.customerPublicID, 'KBATCH')
        .pipe(
          filter(configuration => configuration.data.length > 0 && configuration.data[0].status !== undefined),
          tap(data => { this.configurationStatus = data.data[0].status; }),
          catchError(error => {
            console.log('Failed while trying to get the configuration details.', error);
            return of(null);
          })
        )
        .subscribe();
    }
  }

  downloadFile(url: string, name: string, createdDate?: string) {
    this.spinnerService.show();
    const fileName = this.fileUtilsService.getFileExtension(url);
    const fileNameWithDate = this.fileUtilsService.getCleanName(name, createdDate);
    
    this.processService.downloadfile(url)
      .pipe(
        takeUntil(this.destroy$),
        tap(res => {
          const blob = new Blob([res.body], { type: res.body.type });
          const file = new File([blob], fileNameWithDate + "." + fileName, { type: res.body.type });
          fs.saveAs(file);
          this.spinnerService.hide();
        }),
        catchError((error: HttpErrorResponse) => {
          this.spinnerService.hide();
          console.error('Failed while trying to the download the file. ' + error.error);
          return of(null);
        })
      )
      .subscribe();
  }

  getDateMoment(val: Date): string {
    const dateForma = moment(val).format("DD/MM/YYYY");
    return dateForma;
  }

  getUserName() {
    try {
      if ('metadata' in this.batchDetails && this.batchDetails.metadata != null && this.batchDetails.metadata != undefined) {
        const metadataJson = JSON.parse(this.batchDetails.metadata)
        return metadataJson.user.name;
      }
      return "";
    } catch {
      console.error('No name available in metadata');
      return "";
    }
  }

  getBatchDetails(batch_id: string) {
    this.batchDetails = {};
    this.userName = "";
    this.spinnerService.show();
    this.processService.getBatchDetails(batch_id)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          this.batchDetails = data;
          if ('total_records' in this.batchDetails) {
            this.batchDetails.total_records = this.batchDetails.total_records !== undefined ? this.batchDetails.total_records : '0';
          }
          this.userName = this.getUserName();
          this.spinnerService.hide();
        }),
        catchError((error: HttpErrorResponse) => {
          this.spinnerService.hide();
          console.error('Failed while trying to get the batch details. ' + error.error);
          return of(null);
        })
      )
      .subscribe();
  }

  removeT(val) {
    if (val != null && val != undefined) {
      return val.replace('T', ' ')
    }
  }

  getFileIcon(fileName: string) {
    const extension = fileName.split('.').pop();
    const iconMap = {
      txt: this.icons.txtFile.path,
      xls: this.icons.xlsFile.path,
      xlsx: this.icons.xlsxFile.path,
      csv: this.icons.csvFile.path
    };
    return iconMap[extension] || null;
  }

  getProcessDetails() {
    this.spinnerService.show();
    this.displayLoaderSpinner = true;
    this.processService.getProcessNew(this.customerPublicID)
      .pipe(
        takeUntil(this.destroy$),
        map(data => {
          let resources = data.data;
          resources.forEach(element => {
            if (element.metadata.user != undefined && element.metadata.user.name != undefined) {
              if (element.metadata.user.name == "undefined") {
                element.metadata.user.name = undefined;
              }
            }
          });
          return resources;
        }),
        tap(resources => {
          this.dataSource.data = resources;
          this.totalSize = resources.length;
          this.batchesList = resources;
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Failed while trying to the Process Search All Result. ' + error.error);
          return of(null);
        }),
        finalize(() => {
          this.displayLoaderSpinner = false;
          this.spinnerService.hide();
        })
      )
      .subscribe();
  }

  listenWindowWidth() {
    const minWidthAllow = 1070;
    this.windowService.resizeObservable$
      .pipe(
        debounceTime(200),
        takeUntil(this.destroy$)
      )
      .subscribe((e: Event) => {
        this.displayMonths = e.target['innerWidth'] > 1070 ? 2 : 1;
      });
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  isFromDate(date: NgbDate) {
    return date.equals(this.fromDate);
  }

  isToDate(date: NgbDate) {
    return this.toDate && date.equals(this.toDate);
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  selectDateOption(option: number) {
    this.creationFormControl.patchValue(option);
    this.showOverlay = !this.showOverlay;
    if (option !== 9) {
      this.dateText = this.ddlCreation.find(el => el.value === option).name;
      this.fromDate = null;
      this.toDate = null;
    }
    this.filterCreationDetails(option);
  }

  filterCreationDetails(creation: number) {
    const currentDate = new Date();

    const currentweekFirstDate = new Date();
    const currentweekLastDate = new Date();
    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    const lastweekFirstDate = new Date();
    const lastweekLastDate = new Date();
    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    const currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    const currentYearFirstDate = new Date(currentDate.getFullYear(), 0, 1);
    const currentYearLastDate = new Date(currentDate.getFullYear(), 11, 31);

    const lastYearFirstDate = new Date(currentDate.getFullYear() - 1, 0, 1);
    const lastYearLastDate = new Date(currentDate.getFullYear() - 1, 11, 31);

    let startDateVar;
    let endDateVar;

    switch (Number(creation)) {
      case 0: {
        // Today Filter Condition
        currentDate.setDate(currentDate.getDate());
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      }
      case 1:
        // Yesterday Filter Condition
        currentDate.setDate(currentDate.getDate() - 1);
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 2:
        // Current Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 3:
        // Last Week Filter Condition
        startDateVar = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
        endDateVar = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US');
        break;
      case 4:
        // Current Month Filter Condition
        startDateVar = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
        endDateVar = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US');
        break;
      case 5:
        // Last Month Filter Condition
        startDateVar = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
        endDateVar = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US');
        break;
      case 6:
        // Current Year Filter Condition
        startDateVar = this.convertGMTTime(new Date((formatDate(currentYearFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(currentYearLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        break;
      case 7:
        // Last Year Filter Condition
        startDateVar = this.convertGMTTime(new Date((formatDate(lastYearFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(lastYearLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        break;
      case 8: {
        // All Datas Condition
        startDateVar = 'All';
        endDateVar = 'All';
        break;
      }
      case 9: {
        // Custom Filter Condition
        const startDatePicker = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
        const endDatePicker = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
        startDateVar = formatDate(startDatePicker, 'yyyy-MM-dd 00:00:00', 'en-US');
        endDateVar = formatDate(endDatePicker, 'yyyy-MM-dd 23:59:59', 'en-US');
        break;
      }
      default:
        startDateVar = this.setTodayValueFilter('00:00:00');
        endDateVar = this.setTodayValueFilter('23:59:59');
        break;
    }
    this.startDate = startDateVar;
    this.endDate = endDateVar;
    this.filter();
  }

  setTodayValueFilter(hour: string) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }

  convertGMTTime(startDate1) {
    const offsetTimeZone: number = Number(this.offsetTimeZone);
    const offsetMinutes: number = Number(this.offsetMinutes);
    if (offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      const dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    } else {
      const startDate2 = new Date(startDate1.setHours(startDate1.getHours() - offsetTimeZone));
      const startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  toggleDateRangePicker() {
    this.showOverlay = !this.showOverlay;
  }

  applyFilter() {
    this.filter();
  }

  get filteredState(): BatchStatusV2 {
    const filterState = this.stateOptions.find(el => el.value === this.stateSelectedValue);
    return filterState;
  }

  selectStateOption(selectedState: number) {
    this.stateSelectedValue = selectedState || 0;
    this.state = this.stateSelectedValue;
    if (selectedState == this.stateOptions[0].value) {
      this.state = 0;
    } else if (selectedState == this.stateOptions[1].value) {
      this.state = 1
    } else if (selectedState == this.stateOptions[2].value) {
      this.state = 2
    } else if (selectedState == this.stateOptions[3].value) {
      this.state = 6
    } else if (selectedState == this.stateOptions[4].value) {
      this.state = 4
    } else {
      this.state = selectedState;
    }
    this.filter();
  }

  get filteredTypeName(): BatchTypeV2 {
    const filterType = this.typeOptions.find(item => item.value === this.typeSelectedValue);
    return filterType;
  }

  selectTypeOption(selectedType: number) {
    this.typeSelectedValue = selectedType || 0;
    this.type = this.typeSelectedValue;
    if (selectedType == 0) {
      this.type = 0;
    } else {
      this.type = selectedType;
    }
    this.filter();
  }

  filter() {
    let tempFilterData = this.batchesList;
    if (this.startDate != "All" && this.endDate != "All") {
      if ((this.startDate != undefined && this.startDate != null) && (this.endDate != undefined && this.endDate != null)) {
        tempFilterData = tempFilterData.filter(data => data.created >= this.startDate && data.created <= this.endDate)
      } else {
        tempFilterData = this.batchesList;
      }
    } else {
      tempFilterData = this.batchesList;
    }

    if (this.state != 0) {
      if (this.state == 2) {
        tempFilterData = tempFilterData.filter(data => data.status == 2 || data.status == 3 || data.status == 5)
      } else {
        tempFilterData = tempFilterData.filter(data => data.status == this.state)
      }
    }

    if (this.type != 0) {
      tempFilterData = tempFilterData.filter(data => data.type == this.type)
    }

    if (this.searchFilterForm.controls.searchText.value.length > 0) {
      const searchValue = this.searchFilterForm.controls.searchText.value.trim();
      tempFilterData = tempFilterData.filter(data => data.name.toLowerCase().includes(searchValue.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
    this.paginator.firstPage();
  }

  initSearchForm() {
    this.searchFilterForm = this.formBuilder.group({
      searchText: ['']
    });
  }

  setIcons() {
    return {
      bluePlus: bluePlusIcon,
      searchIcon: searchIcon,
      filterLines: filterLinesIcon,
      dotsVertical: dotsVerticalIcon,
      edit: editIcon,
      copy: copyIcon,
      uploadArrow: uploadArrowIcon,
      calendar: calendarIcon,
      txtFile: txtFileIcon,
      xlsFile: xlsFileIcon,
      xlsxFile: xlsxFileIcon,
      csvFile: csvFileIcon,
      arrow: arrowNarrowIcon,
      checkOutline: checkOutlineIcon
    };
  }

}
